import { useCallback, useState } from 'react';

type UseDrawerStickyHeader = {
  isFixed: boolean;
  contentHeight: number;
  onStickyChange: (isFixed: boolean) => void;
  onStickyContentHeightChange: (contentHeight: number) => void;
};

export const useDrawerStickyHeader = (): UseDrawerStickyHeader => {
  const [stickyHeaderState, setStickyHeaderState] = useState<{
    isFixed: boolean;
    contentHeight: number;
  }>({ isFixed: false, contentHeight: 0 });

  const onStickyChange = useCallback((isFixed: boolean): void => {
    setStickyHeaderState((prev) => ({ ...prev, isFixed }));
  }, []);

  const onStickyContentHeightChange = useCallback((contentHeight: number) => {
    setStickyHeaderState((prev) => ({ ...prev, contentHeight }));
  }, []);

  return {
    isFixed: stickyHeaderState.isFixed,
    contentHeight: stickyHeaderState.contentHeight,
    onStickyChange,
    onStickyContentHeightChange,
  };
};
